import * as types from './mutations-types'

export default {
  [types.MEMBER_DETAIL] (state, data) {
    if (data.occupation) {
      data.occupation = data.occupation + ''
    }
    if (data.hobby) {
      data.hobby = data.hobby + ''
    }
    if (data.vehicleUse) {
      data.vehicleUse = data.vehicleUse + ''
    }
    if (data.gender) {
      data.gender = data.gender + ''
    }
    state.memberDetail = data
  },
  [types.SCAN_CODE] (state, data) {
    state.qrCode = data
  },
  [types.CANCEL_TYPE_OPTIONS] (state, data) {
    state.cancelTypeOptions = data
  },
  [types.MEMBER_CAR_ATTRIBUTION] (state, data) {
    state.memberCarAttribution = data
  },
  [types.EMPTY_QR_CODE] (state, data) {
    state.qrCode = ''
  },
  [types.FINANCIAL_PROJECT_INSTANCE] (state, data) {
    state.myItemDataList = data.dataList
    state.myItemTotalRecord = data.totalRecord
  },
  [types.STORED_VALUE_RECORD] (state, data) {
    state.storedValueRecordData = data.dataList
    state.storedValueRecord = data.totalRecord
  },
  [types.CAR_BRAND_OPTIONS] (state, data) {
    state.memberCarBrandOptions = data
  },
  [types.CAR_TYPE_NAME_OPTIONS] (state, data) {
    state.memberCarTypeNameOptions = data
  },
  [types.MARITAL_STATUS] (state, data) {
    state.maritalStatus = data
  },
  [types.TYPE_OCCUPATION] (state, data) {
    state.occupation = data
  },
  [types.TYPE_HOBBY] (state, data) {
    state.hobby = data
  },
  [types.TYPE_VEHICLE_USE] (state, data) {
    state.vehicleUse = data
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/store/mutations.js